import React from 'react';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';
import OrdersList from './components/orders-list/OrdersList';

const ProductionVolumeChart = React.lazy(() => import('@views/dashboard/admin/charts/production-volume/ProductionVolumeChart'));
const OrdersVolumeChart = React.lazy(() => import('@views/dashboard/admin/charts/orders-volume/OrdersVolumeChart'));

export default function Body() {
    return <React.Suspense fallback={<NowLoadingMessage/>}>
        <div className="row">
            {[
                ProductionVolumeChart,
                OrdersVolumeChart,
            ].map((Component, i) => {
                return <div key={i} className="col-sm-12 col-md-6 mb-4">
                    <Component/>
                </div>;
            })}
        </div>

        <OrdersList controllerName="Orders" isIsolatedComponent/>
    </React.Suspense>;
}
